import uiI18n from "../i18n";

// Display labels of governorates and delegations. Only the visible label changes: the value sent to
// the API, stored, used by filters, aliases, geocoding and the map stays the canonical (French) name.
// Labels come from the existing i18n catalogs ("cities" / "delegations"); an unknown value falls
// back to the canonical name, so nothing is ever invented.
const label = (key, value, language) =>
  uiI18n.t(key, { lng: language || uiI18n.language, defaultValue: value });

export const isArabic = (language) => String(language || "").split("-")[0] === "ar";

export const cityLabel = (city, language) => (city ? label(`cities.${city}`, city, language) : "");

export const delegationLabel = (city, delegation, language) =>
  delegation ? label(`delegations.${city}.${delegation}`, delegation, language) : "";

// Canonical values as { value, label } options. In Arabic they are sorted by their Arabic label;
// other languages keep the catalog order.
export function placeOptions(values, toLabel, language) {
  const options = values.map((value) => ({ value, label: toLabel(value) }));
  return isArabic(language) ? options.sort((a, b) => a.label.localeCompare(b.label, "ar")) : options;
}

// Display only: drops a location segment already shown ("Hergla, Hergla, Sousse" -> "Hergla, Sousse").
// Each segment is [canonical, label]; two segments are the same when either form matches, ignoring case,
// spaces and word order. Empty / "null" / "undefined" segments are dropped. Returns the visible labels.
const placeKey = (value) => String(value || "").trim().toLowerCase().split(/\s+/).filter(Boolean).sort().join(" ");

export function uniquePlaceParts(segments) {
  const seen = new Set();
  return segments.reduce((labels, [canonical, text]) => {
    const keys = [placeKey(canonical), placeKey(text)].filter((key) => key && key !== "null" && key !== "undefined");
    if (!keys.length || keys.some((key) => seen.has(key))) return labels;
    keys.forEach((key) => seen.add(key));
    return [...labels, String(text || canonical).trim()];
  }, []);
}
